<template>
  <form enctype="multipart/form-data">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{skill_id ? 'Update' : 'Create'}} Skill</p>
      </header>
      <div class="modal-card-body">
        <!--Loading-->
        <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
        <b-field label="Name">
          <b-input
            v-model="skill.name"
            ref="title"
            minlength="3"
            required
            type="text"
            placeholder="Add skill name here"
          ></b-input>
        </b-field>
        <b-field label="Remarks">
          <b-input
            ref="remarks"
            v-model="skill.remarks"
            type="textarea"
            placeholder="Add any remarks"
          ></b-input>
        </b-field>
        <b-field label="Status">
          <b-switch
            v-model="skill.status"
            type="is-success"
          >{{skill.status ? 'Active' : 'Non-Active'}}</b-switch>
        </b-field>
        <b-field label="Not Allow Attempt">
          <b-switch
            v-model="skill.is_not_allowed"
            type="is-success"
          >{{skill.is_not_allowed ? 'Active' : 'Non-Active'}}</b-switch>
        </b-field>
        <button
          type="button"
          @click.prevent="proceed()"
          class="button is-success btn-center"
        >{{skill_id ? 'Update' : 'Create'}}</button>
      </div>
    </div>
  </form>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "set-skill",
  data() {
    return {
      // announcementfiles: null,
      isLoading: false,
      skill : {
        name: "",
        category : null,
        remarks : "",
        status : true,
        is_not_allowed : false,
      }
    };
  },
  props: {
    skill_id: {
      type: String,
      default: null,
    },
    category_id : {
      type: String,
      required: true,
    }
  },
  computed: {
    ...mapGetters(["getTeacherToken", "fetchCurrentSkill"]),
  },
  methods: {
    ...mapActions([
      "createSkill",
      "updateSkill",
      "loadSkillDetails",
    ]),
    deleteExistingFile(index) {
      this.editfiles[index].is_deleted = true;
    },
    proceed() {
      let is_validate = this.$refs.title.checkHtml5Validity()
      this.skill.category = this.category_id
      if (is_validate) {
        this.isLoading = true;
        if (this.skill_id) {
          //For editing a skill
          this.updateSkill({
            id: this.skill_id,
            skill: this.skill,
            token: this.getTeacherToken,
          })
          .then(() => {
            this.isLoading = false;
            this.$emit("over");
            this.$buefy.toast.open({
              message: "Skill updated successfully",
              type: "is-success",
            });
          })
          .catch((err) => {
            this.isLoading = false;
            this.$emit("over");
            console.log(err)
            this.$buefy.toast.open({
              message: err.response.data,
              type: "is-danger",
            });
          });
        } else {
          //For creating a new skill
          this.createSkill({
            skill: this.skill,
            token: this.getTeacherToken,
          })
          .then(() => {
            this.isLoading = false;
            this.$emit("over");
            this.$buefy.toast.open({
              message: "Skill created successfully",
              type: "is-success",
            });
          })
          .catch((err) => {
            this.isLoading = false;
            this.$emit("over");
            this.$buefy.toast.open({
              message: err.response.data,
              type: "is-danger",
            });
          });
        }
      }
    },
  },
  async created() {
    if (this.skill_id){
      this.isLoading = true;
      await this.loadSkillDetails({
        id: this.skill_id,
        token: this.getTeacherToken,
      })

      for(let key in this.skill){
        this.skill[key] = this.fetchCurrentSkill[key]
      }
      // this.editfiles = this.fetchCurrentSkill.files.map((file_name) => {
      //   return {
      //     name: this.$common.fileBasename(file_name),
      //     is_deleted: false,
      //   }
      // })
      this.isLoading = false;
    }
  },
};
</script>
<style scoped>
</style>